import React from 'react';
import { getProfileOptions } from '@utils/profileUtils';
import { Profile } from '@constants';

type ProfileOptionsProps = {
    profile: Profile
}

export const ProfileOptions = ({ profile }: ProfileOptionsProps) => {
    const profileOptions = getProfileOptions(profile);

    return (
        <>
            {
                profileOptions.map(profile => {
                    return (
                        <option
                            key={profile} 
                            data-name={profile} 
                            value={profile}>
                                {profile}
                        </option>
                    );
                })
            }
        </>
    );
};

export default ProfileOptions;
